var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointerDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 11.6577C19 13.0343 18.0412 14.2342 16.6745 14.5681L10.813 16V20.5C10.813 21.3284 10.1257 22 9.27792 22C8.43013 22 7.74285 21.3284 7.74285 20.5V11.5L6.41588 13.5747C5.78588 14.5596 4.38195 14.7159 3.54143 13.8946C2.99183 13.3575 2.84477 12.5418 3.17346 11.8536L6.20779 5.5C7.13905 3.3767 9.27567 2 11.6398 2H13.8831C16.7091 2 19 4.23858 19 7V11.6577Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointerDown);
export default __webpack_public_path__ + "static/media/pointer-down.f31b4755d781a4bfdbd7a1ae27166056.svg";
export { ForwardRef as ReactComponent };